/**
 * Created by vladislav on 4/2/2024
 */

const AdsManager = function () {
    this._isStickyPlaying = false;
    this._isStickyEnabled = false;

    this.isAdBlockEnabled = false;

    connector.ads.on("changeStatus", () => {
        if (connector.ads.isConnected()) {
            this.checkCacheQueue();
            this.checkAdBlock();
        }

        if (this._isStickyEnabled) {
            this._refreshStickyInner();
        }
    });

    connector._countryManager.on("changed", () => {
        this.whenIdle(() => {
            connector.ads._refreshPlugin();
        });
    });

    connector.ads.on("pluginChanged", () => {
        this._isStickyPlaying = false;
    });

    connector.timeouts.setInterval(() => this.checkCacheQueue(), AdsPlugin.CHECK_CACHE_INTERVAL);
};

AdsManager.prototype.getAdStatus = function (type) {
    if (type === AdsPlugin.REWARDED) {
        return this.getRewardedStatus();
    }

    if (type === AdsPlugin.INTERSTITIAL) {
        return this.getInterstitialStatus();
    }

    if (type === AdsPlugin.STICKY) {
        return this.getStickyStatus();
    }
};

AdsManager.prototype.getRewardedStatus = function () {
    const plugin = connector.ads.getPlugin();

    if (!plugin.isConnected()) {
        return ERRORS.NOT_CONNECTED;
    }

    if (!plugin.isRewardedSupported()) {
        return ERRORS.SHOW_REWARDED.NOT_SUPPORTED;
    }

    if (!plugin.units.rewarded.isCached()) {
        return ERRORS.SHOW_REWARDED.NO_ADS;
    }

    if (!plugin.isRewardedConfigured()) {
        return ERRORS.SHOW_REWARDED.NOT_CONFIGURED;
    }

    return connector.CODE_SUCCEED;
};

AdsManager.prototype.getInterstitialStatus = function () {
    const plugin = connector.ads.getPlugin();

    if (!plugin.isConnected()) {
        return ERRORS.NOT_CONNECTED;
    }

    if (!plugin.isInterstitialSupported()) {
        return ERRORS.SHOW_INTERSTITIAL.NOT_SUPPORTED;
    }

    if (plugin.isThrottled(AdsPlugin.INTERSTITIAL)) {
        return ERRORS.SHOW_INTERSTITIAL.THROTTLED;
    }

    if (!plugin.units.interstitial.isCached()) {
        return ERRORS.SHOW_INTERSTITIAL.NO_ADS;
    }

    if (!plugin.isInterstitialConfigured()) {
        return ERRORS.SHOW_INTERSTITIAL.NOT_CONFIGURED;
    }

    return connector.CODE_SUCCEED;
};

AdsManager.prototype.getStickyStatus = function () {
    const plugin = connector.ads.getPlugin();

    if (!plugin.isConnected()) {
        return ERRORS.NOT_CONNECTED;
    }

    if (!plugin.isStickySupported()) {
        return ERRORS.SHOW_STICKY.NOT_SUPPORTED;
    }

    if (!plugin.isStickyConfigured()) {
        return ERRORS.SHOW_STICKY.NOT_CONFIGURED;
    }

    if (!plugin.isStickyAvailable()) {
        return ERRORS.SHOW_STICKY.NO_STICKY;
    }

    return connector.CODE_SUCCEED;
};

AdsManager.prototype.showRewarded = function (callback) {
    this.playAd(AdsPlugin.REWARDED, (code, data = {}) => {
        const plugin = connector.ads.getPlugin();
        const pluginName = data.pluginName || plugin.pluginName;

        if (code && code !== ERRORS.SHOW_REWARDED.CLOSED_BY_USER) {
            plugin.bus.trigger("error:showRewarded", code);

            connector.metrics.logEvent(connector.EVENTS.ADS.ERROR_REWARDED, {
                plugin: pluginName,
                error: code,
                details: data.raw ? { raw: connector.utils.stringify(data.raw).substring(0, 200) } : undefined
            });
        }

        if (code === ERRORS.SHOW_REWARDED.CLOSED_BY_USER) {
            connector.metrics.logEvent(connector.EVENTS.ADS.CLOSED + AdsPlugin.REWARDED, { itemId: pluginName });
        }

        if (code === connector.CODE_SUCCEED) {
            connector.metrics.logEvent(`${connector.EVENTS.ADS.FINISH + AdsPlugin.REWARDED}_${pluginName}`);
        }

        callback(code);
    });
};

AdsManager.prototype.showInterstitial = function (callback) {
    this.playAd(AdsPlugin.INTERSTITIAL, (code, data = {}) => {
        const plugin = connector.ads.getPlugin();
        const pluginName = data.pluginName || plugin.pluginName;

        if (code && code !== ERRORS.SHOW_INTERSTITIAL.CLOSED_BY_USER) {
            plugin.bus.trigger("error:showInterstitial", code);

            connector.metrics.logEvent(connector.EVENTS.ADS.ERROR_INTERSTITIAL, {
                plugin: pluginName,
                error: code,
                details: data.raw ? { raw: connector.utils.stringify(data.raw).substring(0, 200) } : undefined
            });
        }

        if (code === ERRORS.SHOW_INTERSTITIAL.CLOSED_BY_USER) {
            connector.metrics.logEvent(connector.EVENTS.ADS.CLOSED + AdsPlugin.INTERSTITIAL, { itemId: pluginName });
        }

        if (code === connector.CODE_SUCCEED) {
            connector.metrics.logEvent(`${connector.EVENTS.ADS.FINISH + AdsPlugin.INTERSTITIAL}_${pluginName}`);
        }

        callback(code);
    });
};

AdsManager.prototype.isStickyPlaying = function () {
    return this._isStickyPlaying;
};

AdsManager.prototype.enableSticky = function (options, callback) {
    if (this._isStickyEnabled) {
        callback();

        return;
    }

    this._isStickyEnabled = true;
    this._updateRefreshInterval();

    this.showSticky(callback, options);
};

AdsManager.prototype.disableSticky = function (callback) {
    if (!this._isStickyEnabled) {
        callback();

        return;
    }

    this._isStickyEnabled = false;
    this._updateRefreshInterval();

    this.closeSticky(callback);
};

AdsManager.prototype.showSticky = function (callback, options) {
    const plugin = connector.ads.getPlugin();

    const onError = function (code) {
        plugin.bus.trigger("error:showSticky", code);

        callback(code);
    };

    const code = this.getAdStatus(AdsPlugin.STICKY);
    if (code) {
        onError(code);

        return;
    }

    plugin.showSticky((code, bannerSize) => {
        if (code) {
            onError(code);

            return;
        }

        this._isStickyPlaying = true;

        plugin.bus.trigger("sticky:start", bannerSize);

        callback(code);
    }, options);
};

AdsManager.prototype._refreshStickyInner = function (callback) {
    if (this._refreshingSticky) {
        callback && callback(connector.CODE_FAILED);

        return;
    }

    this._refreshingSticky = true;

    const plugin = connector.ads.getPlugin();

    const onDone = function (code) {
        this._refreshingSticky = false;

        if (!this._isStickyEnabled) {
            callback && callback(code);

            this.closeSticky();
            return;
        }

        if (code) {
            plugin.bus.trigger("error:refreshSticky", code);
        }

        plugin.bus.trigger("sticky:refresh");

        callback && callback(code);
    }.bind(this);

    if (this._isStickyPlaying && !connector.ads.isStickyAvailable) {
        this.closeSticky(onDone);
        return;
    }

    if (!this._isStickyPlaying && connector.ads.isStickyAvailable) {
        this.showSticky(onDone);
        return;
    }

    if (plugin.refreshSticky) {
        plugin.refreshSticky((code) => {
            if (code) {
                this.closeSticky();
            }

            onDone(connector.CODE_SUCCEED);
        });
        return;
    }

    onDone(connector.CODE_SUCCEED);
};

AdsManager.prototype._updateRefreshInterval = function () {
    const isActive = this._isStickyEnabled;

    if (!isActive && this._refreshInterval !== undefined) {
        connector.timeouts.clearInterval(this._refreshInterval);
        this._refreshInterval = undefined;
    } else if (isActive && this._refreshInterval === undefined) {
        const plugin = connector.ads.getPlugin();
        const interval = plugin.stickyRefreshInterval || AdsManager.REFRESH_STICKY_INTERVAL;

        this._refreshInterval = connector.timeouts.setInterval(() => this._refreshStickyInner(), interval);
    }
};

AdsManager.prototype.refreshSticky = function (callback) {
    this._refreshStickyInner(callback);
};

AdsManager.prototype.closeSticky = function (callback) {
    const plugin = connector.ads.getPlugin();

    if (!this._isStickyPlaying) {
        callback && callback(connector.CODE_SUCCEED);
        return;
    }

    const onError = function (code) {
        plugin.bus.trigger("error:closeSticky", code);

        callback && callback(code);
    };

    plugin.closeSticky((code) => {
        if (code) {
            onError(code);

            return;
        }

        this._isStickyPlaying = false;

        plugin.bus.trigger("sticky:close");

        callback && callback(code);
    });
};

AdsManager.prototype.onStickyRestored = function (bannerSize) {
    this._isStickyPlaying = true;

    const plugin = connector.ads.getPlugin();

    plugin.bus.trigger("sticky:start", bannerSize);
};

AdsManager.prototype.onStickyClosedByUser = function () {
    this._isStickyPlaying = false;

    const plugin = connector.ads.getPlugin();

    plugin.bus.trigger("sticky:close");
};

AdsManager.prototype.isAdSupported = function (type) {
    if (type === AdsPlugin.REWARDED) {
        return connector.ads.isRewardedSupported;
    }

    if (type === AdsPlugin.INTERSTITIAL) {
        return connector.ads.isInterstitialSupported;
    }

    if (type === AdsPlugin.STICKY) {
        return connector.ads.isStickySupported;
    }
};

AdsManager.prototype.checkAdBlock = function (callback) {
    const plugin = connector.ads.getPlugin();

    const onDone = function (enabled) {
        this.isAdBlockEnabled = enabled;

        callback && callback(enabled);
    }.bind(this);

    if (connector.info.isNative || connector.info.isInApp) {
        onDone(false);
        return;
    }

    if (plugin.checkAdBlock) {
        if (plugin.isConnected()) {
            plugin.checkAdBlock(onDone);
        } else {
            onDone(false);
        }

        return;
    }

    // Multi-signal bait test. 150ms wait lets adblocker CSS / DOM
    // observers apply (uBlock procedural filters can fire >50ms after
    // insertion). Element kept off-screen with explicit dimensions so a
    // non-blocking page can't accidentally collapse it to zero height —
    // if anything below evaluates "hidden" now it's because a blocker
    // hid it. Six visibility signals catch display:none, visibility,
    // opacity, removal, and detached-ancestor variants.
    const div = document.createElement("div");
    div.className = "adsbox ad-banner advertisement pub_300x250 google_ads text-ad sponsored";
    div.id = "ad-banner";
    div.innerHTML = "&nbsp;";
    Object.assign(div.style, {
        width: "10px",
        height: "10px",
        position: "absolute",
        top: "-9999px",
        left: "-9999px",
        pointerEvents: "none"
    });
    document.body.appendChild(div);

    setTimeout(() => {
        const cs = window.getComputedStyle(div);
        const blocked = div.parentNode === null
            || div.offsetParent === null
            || div.offsetHeight === 0
            || div.clientHeight === 0
            || cs.display === "none"
            || cs.visibility === "hidden"
            || parseFloat(cs.opacity) === 0;
        onDone(blocked);
        if (div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }, 150);
};

AdsManager.prototype.whenIdle = function (callback) {
    const plugin = connector.ads.getPlugin();

    if (!plugin) {
        callback();
        return;
    }

    if (plugin.isIdle()) {
        callback();
    } else {
        const listener = plugin.bus.on("changeVideoState", () => {
            if (plugin.isIdle()) {
                callback();

                listener.clear();
            }
        });
    }
};

AdsManager.prototype.checkCacheQueue = function () {
    if (connector.ads.isConnected()) {
        const plugin = connector.ads.getPlugin();

        if (plugin.cantLoadInParallel) {
            AdsPlugin.TYPES.slice().reverse().reduce((next, name) => function () {
                plugin.cacheAd(name, next);
            }, () => {})();
        } else {
            AdsPlugin.TYPES.forEach((name) => {
                plugin.cacheAd(name);
            });
        }
    }
};

AdsManager.prototype.askPermission = function (callback) {
    const plugin = connector.ads.getPlugin();

    plugin.askPermission(() => {
        connector.ads.connect();

        if (callback) {
            callback();
        }
    });
};

AdsManager.prototype.playAd = function (name, callback) {
    callback = callback || function () {};

    const code = this.getAdStatus(name);
    if (![connector.CODE_SUCCEED, ERRORS.SHOW_INTERSTITIAL.NO_ADS, ERRORS.SHOW_REWARDED.NO_ADS].includes(code)) {
        callback(code);
        return;
    }

    const plugin = connector.ads.getPlugin();

    plugin.bus.trigger(`${name}:loading`, plugin.pluginName);

    plugin.cacheAd(name, (code) => {
        plugin.bus.trigger(`${name}:loaded`, code === connector.CODE_SUCCEED, plugin.pluginName);

        if (code !== connector.CODE_SUCCEED) {
            if (name === AdsPlugin.REWARDED) {
                callback(ERRORS.SHOW_REWARDED.NO_ADS);
            } else {
                callback(ERRORS.SHOW_INTERSTITIAL.NO_ADS);
            }
            return;
        }

        plugin.playAd(name, (code, data) => {
            AdsPlugin.TYPES.forEach((type) => {
                const delay = type === name && plugin.cantLoadAfterPlay ? AdsPlugin.LOAD_AFTER_PLAY_TIME : 0;
                setTimeout(plugin.cacheAd.bind(plugin, type), delay);
            });

            callback(code, data);
        });

        plugin.cacheAd(name);
    });
};

AdsManager.prototype.loadECPMConfig = function () {
    const config = window.CONNECTOR_ECPM;
    if (!config.remote || !config.remote.startsWith("remoteconfig://") || !connector.config.remoteConfigURL || this.ecpmConfigLoading) {
        return;
    }

    this.ecpmConfigLoading = true;

    connector._loadConfig(config.remote, (config) => {
        window.CONNECTOR_ECPM = config || window.CONNECTOR_ECPM;
        this.ecpmConfigLoading = false;
    });
};

AdsManager.REFRESH_STICKY_INTERVAL = connector.utils.parseInterval("60 seconds");